<!-- 预订车位    -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KNTYVWC",
                "optType":1,
                "orderSeq": "123456",
                "stallCode": "A1234",
                "tel": "13800138000",
                "carCode": "粤TEST01",
                "reserveFrom": "2017-11-07 00:00:00",
                "reserveTo": "2017-11-07 10:00:00",
                "amountMoney": 10.00,
                "bookingFee": 0.00,
                "parkingFee": 10.00,
                "handlingFee": 0.00,
                "source": "智慧停车APP",
                "operateTime": "2017-11-07 00:00:00",
                "operator": "admin123",
                "customVipName": "测试VIP",
                "carOutCancel":0
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台进行车位预订",
                t_url: this.commonUrls.test+"bookingSpace",
                p_url: this.commonUrls.prod+"bookingSpace",
                precondition: "VEMS 2.13及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'optType', info2: '是', info3: 'int', info4: '操作类型0:新增，1:修改' },
                        { info1: 'orderSeq', info2: '是', info3: 'String', info4: '订单编号' },
                        { info1: 'stallCode', info2: '否', info3: 'String', info4: '车位编号' },
                        { info1: 'tel', info2: '是', info3: 'String', info4: '预订手机号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '预订车牌' },
                        { info1: 'reserveFrom', info2: '是', info3: 'String', info4: '预留时间段开始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'reserveTo', info2: '是', info3: 'String', info4: '预留时间段(截至时间)，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'amountMoney', info2: '是', info3: 'decimal', info4: '预订总计' },
                        { info1: 'bookingFee', info2: '是', info3: 'decimal', info4: '预订费' },
                        { info1: 'parkingFee', info2: '是', info3: 'decimal', info4: '预订停车费' },
                        { info1: 'handlingFee', info2: '是', info3: 'decimal', info4: '手续费' },
                        { info1: 'source', info2: '是', info3: 'String', info4: '订单来源' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间,yyyy-MM-dd HH:mm:ss' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作人' },
                        { info1: 'customVipName', info2: '是', info3: 'String', info4: '对应的VIP名称' },
                        { info1: 'carOutCancel', info2: '是', info3: 'int', info4: '车辆离场失效 0否，1是' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作人' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间,yyyy-MM-dd HH:mm:ss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/shareBooking/bookingSpace.vue